<div class="row">
    <div class="col ">
        <div class="canvas-toolbar btn-group-vertical">
            <button type="button" class="btn btn-outline-primary btn-sm" (click)="openimage()"
                matTooltip="Show image in high resolution  Tip: You can click on image too."><i class="fas fa-expand-alt"></i></button>
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="addIssueFromImage($event)"
                matTooltip="Add new issue from this image"><i class="far fa-window-close"></i></button>
            
            <ng-container *ngIf="toolbarOptions.showFilters">
                <div class="mt-1"></div>
                <button type="button" class="btn btn-sm btn-outline-secondary" (click)="filtergrayscale($event)"
                    matTooltip="Set to grayscale"><i class="fas fa-adjust"></i></button>
                <button type="button" class="btn btn-sm btn-outline-secondary" (click)="filterInvert($event)"
                    matTooltip="Set invert"><i class="fas fa-tint"></i></button>
            </ng-container>

        </div>
        <div class="issue-canvas-container withpointer">
            <app-issuecanvas #issue_canvas [showIssueOnCanvas]="options.showIssueOnCanvas" [issue]="issue" [width]="canvasWidth" [height]="canvasHeight"  [canvas_options]="canvas_options"
                [issueList]="issueList" (click)="openimage()"
                (onRightClick)="canvas_onRightClick($event)">
            </app-issuecanvas>
        </div>

        <div class="issue-stats-container">
            <app-ex-issuerrortype [errortypeObj]="{issueType:issue.type,iconSize:'fa-2x'}"></app-ex-issuerrortype>
            <b class="ml-2" matTooltip="Issue type">{{ui_errortype(issue)}}</b>
            <div>Relevance:<app-issuerelevance [issue]="issue"></app-issuerelevance>
            </div>
            <div>
                <table class="issue-info issue-measures">
                    <tr>
                        <th class="title-section" colspan=2>Measures</th>
                    </tr>
                    <tr>
                        <th>Max</th>
                        <td>{{issue.info?.temperature?.max | number: '2.2-2' }} ºC</td>
                    </tr>
<!--                     <tr>
                        <th>Min</th>
                        <td>{{issue.info?.temperature?.min | number: '2.2-2' }} ºC</td>
                    </tr> -->
                    <tr>
                        <th>Average</th>
                        <td>{{issue.info?.temperature?.average | number: '2.2-2' }} ºC</td>
                    </tr>
                    <tr>
                        <th>Thermal Gradient</th>
                        <td>{{issue.info?.temperature?.gradient | number: '2.2-2' }} ºC</td>
                    </tr>
                    <tr>
                        <th>Thermal Gradient at 1000W/m2</th>
                        <td>{{issue.info?.temperature?.gradient_1kw | number: '2.2-2' }} ºC</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>

</div>